import React from "react";
import { motion } from "framer-motion";
import SEO from "../Seo/SEO";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

export default function TermsCondition() {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <div style={{ paddingTop: "80px" }}>
      <Header />
      <div className="py-8">
      {/* <SEO
        title="Terms & Conditions - pujaguru"
        description="Read pujaguru's terms and conditions. Understand the terms of service, user agreements, and policies for using our online puja booking platform."
        keywords="terms and conditions, terms of service, user agreement, pujaguru terms"
        url="https://staging.pujaguru.org/terms_and_condition"
        canonical="https://staging.pujaguru.org/terms_and_condition"
        noindex={false}
      /> */}
      <div className="container mx-auto px-4">
        {/* <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        > */}
          <h4 className="font-bold text-gray-900 mb-4">
          TERMS & CONDITIONS 
          </h4>
          <p className="md:text-base text-sm text-gray-500 mt-2">
            Last Updated: 13-02-2026
          </p>
          {/* <div className="w-24 h-1 bg-orange-500 mx-auto mt-6 rounded-full"></div> */}
        {/* </motion.div> */}

        <div className="space-y-8">
          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
          >
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                These Terms & Conditions (&quot;Terms&quot;) govern your access to and use of the pujaguru mobile application and website (collectively, the &quot;Platform&quot;).
              </p>
              <p>
                By accessing, registering, or booking any service on pujaguru, you agree to be bound by these Terms. If you do not agree, please discontinue use of the Platform.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.1 }}
          >
            <h5 className="text-xl text-sm font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                1.
              </span>
              ABOUT pujaguru
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                pujaguru is a digital platform that facilitates Hindu religious and spiritual services, including pujas, rituals, chadhava seva, and astrology consultations, through verified temples and priests.
              </p>
              <p>
                pujaguru acts only as a facilitator and does not itself perform any ritual or puja.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.2 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                2.
              </span>
              USER INFORMATION
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                To use the Platform, you may be required to provide:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Full Name</li>
                <li>Email Address</li>
                <li>Mobile Number</li>
              </ul>
              <p>
                You agree that the information provided is true, accurate, and complete. pujaguru shall not be responsible for issues arising due to incorrect details provided by the user.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.3 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                3.
              </span>
              SERVICES
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>All services are offered as per Hindu traditions and religious practices</li>
                <li>Services are faith-based and outcomes may vary</li>
                <li>pujaguru does not guarantee specific results from any puja or consultation</li>
                <li>Descriptions of benefits are based on traditional beliefs and scriptures only.</li>
              </ul>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.4 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                4.
              </span>
              BOOKING & PAYMENTS
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Puja bookings are confirmed only after successful payment</li>
                <li>All prices are displayed in Indian Rupees (INR)</li>
                <li>Payments once made are subject to the applicable refund policy</li>
                <li>pujaguru reserves the right to cancel or reschedule services due to temple schedules, priest availability, or unavoidable circumstances.</li>
              </ul>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.5 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                5.
              </span>
              NO GUARANTEE OF RESULTS
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                pujaguru does not claim or guarantee:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Fulfillment of wishes</li>
                <li>Removal of negative energies or black magic</li>
                <li>Medical, financial, or legal benefits</li>
              </ul>
              <p>
                Users are advised to seek professional guidance for health, financial, or legal matters.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.6 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                6.
              </span>
              USER CONDUCT
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                You agree not to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Misuse the Platform</li>
                <li>Provide false or misleading information</li>
                <li>Violate any applicable law or religious sentiment</li>
              </ul>
              <p>
                Violation may result in suspension or termination of access without notice.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.7 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                7.
              </span>
              LIMITATION OF LIABILITY
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                To the maximum extent permitted by law, pujaguru shall not be liable for:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Any direct or indirect loss</li>
                <li>Emotional or spiritual dissatisfaction</li>
                <li>Delay or non-performance due to circumstances beyond control</li>
              </ul>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.8 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                8.
              </span>
              INTELLECTUAL PROPERTY
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                All content on the Platform, including text, images, logos, and designs, is the intellectual property of pujaguru and may not be copied or reused without written permission.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 0.9 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                9.
              </span>
              MODIFICATION OF TERMS
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                pujaguru reserves the right to modify these Terms at any time. Continued use of the Platform after changes implies acceptance of the revised Terms.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 1.0 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                10.
              </span>
              GOVERNING LAW
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                These Terms shall be governed by and interpreted in accordance with the laws of India. All disputes shall be subject to the jurisdiction of Indian courts.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 1.1 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                11.
              </span>
              CONTACT DETAILS
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                For any questions or support, please contact:
              </p>
              <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                <p><strong>Name:</strong> pujaguru Support</p>
                <p>
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:support@pujaguru.org"
                    className="text-orange-600 hover:text-orange-700 hover:underline focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1 rounded"
                  >
                    support@pujaguru.org
                  </a>
                </p>
                <p>
                  <strong>Mobile:</strong>{" "}
                  <a
                    href="tel:+917201031069"
                    className="text-orange-600 hover:text-orange-700 hover:underline focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1 rounded"
                  >
                    +91 7201031069
                  </a>
                </p>
              </div>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-xl shadow md:p-5 p-3"
            {...fadeInUp}
            transition={{ delay: 1.2 }}
          >
            <h5 className="md:text-2xl text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">
                12.
              </span>
              ACCEPTANCE
            </h5>
            <div className="text-gray-700 space-y-4 md:text-base text-sm">
              <p>
                By using the pujaguru Platform, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
              </p>
            </div>
          </motion.section>
        </div>

        <motion.div
          className="text-center mt-12 md:p-6 p-3 bg-orange-50 rounded-xl border border-orange-200"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.3, duration: 0.8 }}
        >
          <p className="text-gray-700 md:text-base text-sm">
            By using the pujaguru Platform, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
          </p>
        </motion.div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
